import React from 'react';

export const Comment = React.memo(({comment, isLoggedIn, BASE_URL_OPENFORGE}) => {

    return(
        <div>
            <div>
                <div className="d-flex followup-sec-2">
                    <div className="vr"></div>
                </div>
                <div className="card">
                    <div className="card-header box arrow-left followup-clr">
                        <span></span> 
                        <p>
                            <span><b>{comment.submitted_by} {isLoggedIn ? (<a style={{textDecoration: 'none'}}  href={`${BASE_URL_OPENFORGE}/users/${comment.hasOwnProperty('submitted_by') ? comment.submitted_by : ''}`}>({comment.submitted_by_real_name.trim()})</a>): ''}</b> </span> has commented on <span><b>{comment.submitted_on}</b></span>
                        </p>
                    </div>

                    <div className="card-body textarea-box">
                        <p>
                            {/* previous code */}
                            {/* {comment.comment_body} */}
                            {/* new code */}
                            {comment.comment_body.split("\r<br>").map((line, index) => (
                            <React.Fragment key={index}>
                                {line}
                                <br />
                            </React.Fragment>
                            ))}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
});